import React from "react";
import { Text, StyleSheet, Image, View } from "@react-pdf/renderer";
import BCCImage from "../../../../assets/images/bcc/bcc-logo.png";
import { getReportMonthName } from "../utils";

type Props = {
    alias: string;
    freeText: string;
    selectedReportDate: string | undefined;
    firstPageBarChart: string;
    firstPageBarChartText: string[];
}

const styles = StyleSheet.create({
    title: {
        fontFamily: 'Helvetica-Bold',
        marginBottom: 30,
        textAlign: "center",
        color: "#4E73C3",
        lineHeight: 1.5,
    },
    paragraph: {
        fontSize: 11,
        color: "#000",
        lineHeight: 1.5,
    },
    image: {
        width: 337,
        height: 78,
        flexShrink: 0,
        marginLeft: "auto",
        marginRight: "auto",
        marginBottom: 32
    },
    chartImage: {
        width: 499,
        height: 206,
        margin: "auto",
    },
});

const FirstPage = ({ alias, freeText, selectedReportDate, firstPageBarChart, firstPageBarChartText }: Props) => {

    return (
        <View wrap={false}>
            <Image style={styles.image} src={BCCImage} />
            <Text style={{ ...styles.title, fontSize: 16 }}>{alias}{"\n"}Air Quality Report{selectedReportDate ? ` - ${getReportMonthName(selectedReportDate)} 2025` : ""}</Text>
            {firstPageBarChartText.length > 0 && firstPageBarChartText.length === 2 && <Text style={{ ...styles.paragraph, marginBottom: 30, textAlign: "left" }}>
                Daily air quality has typically been{" "}
                <Text style={{ fontFamily: 'Helvetica-Bold' }} wrap={false}>{firstPageBarChartText[0]}</Text> this month, with at least one day experiencing{" "}
                <Text style={{ fontFamily: 'Helvetica-Bold' }} wrap={false}>{firstPageBarChartText[1]}</Text> conditions.
            </Text>}
            {firstPageBarChartText.length > 0 && firstPageBarChartText.length === 1 && <Text style={{ ...styles.paragraph, marginBottom: 30, textAlign: "left" }}>
                Daily air quality has typically been{" "}<Text style={{ fontFamily: 'Helvetica-Bold' }} wrap={false}>{firstPageBarChartText[0]}</Text> this month.
            </Text>}
            <View style={{ marginBottom: 30 }}>
                <Image style={styles.chartImage} src={firstPageBarChart} />
            </View>
            <Text style={{ ...styles.title, fontSize: 14, marginBottom: 16, textAlign: 'left' }}>What’s been happening?</Text>
            <Text style={{ ...styles.paragraph, fontSize: 11 }}>{freeText}</Text>
        </View>
    );
};

export default FirstPage;
